
import { responseUtils } from '../utils';
import { httpStatusCode } from '../errors/http-status-codes';
import { NotificationManager } from 'react-light-notifications';

const reqStatusMapping = new Map([
    [httpStatusCode.NOT_FOUND, {
        title: 'errori.errore',
        message: 'errori.codiceContattoNonTrovato',
    }],
]);

function getEncounterStatus(id, language, intl) {
    const requestOption = {
        method: 'GET',
    };
    return fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/encounter/${id}/${language}`,
        requestOption
    )
        .then(
            res => responseUtils.handleResponse(res, intl, reqStatusMapping),
            error => responseUtils.handleError(error, intl)
        );
}

function getEncountersStatus(ids, language, intl) {
    const requestOption = {
        method: 'GET',
    };

    const promises = ids.map(encounterID => 
        fetch(
            `${process.env.REACT_APP_API_ENDPOINT}/encounter/${encounterID}/${language}`,
            requestOption
        )
        .then(res => {
            if (!res.ok) {
                return Promise.reject(res);
            }

            return res.json();
        })
        .catch(error => new Error(error))
    );

    return Promise.all(promises)
        .then(res => {
            const resolvedPromises = res.filter(
                item => !(item instanceof Error)
            );

            if (resolvedPromises.length < res.length) {
                // We were either not able to restore some encounters
                // or there was an error in one of the request.
                NotificationManager.error({
                    title: intl.formatMessage({ id: 'errori.errore' }),
                    message: intl.formatMessage({ id: 'errori.erroreRipristinoListaEncounter' }),
                    showCloseButton: true,
                    timeout: 1000,
                    priority: false,
                });
            }

            return resolvedPromises;
        });
}

export const encounterServices = {
    getEncounterStatus,
    getEncountersStatus,
};


